import React from 'react';
import Section from 'components/form/section/section';
import Label from 'components/form/label/label';
import Error from './error';
import GoogleAddress from 'components/form/googleAddress/googleAddress';
import { Field } from 'formik';
import classNames from 'classnames';

function ComplexElement(props) {
  let element = props.element;
  let errors = props.errors;
  let handleBlur = props.handleBlur;
  let handleChange = props.handleChange;
  let setFieldValue = props.setFieldValue;
  let touched = props.touched;
  let values = props.values;

  // Logic for rendering rest of child props
  if (element.conditional) {
    if (values[element.conditional.name] !== element.conditional.value) {
      return null;
      // TODO Make sure conditionally required fields update
      //      quick enough; Here, schema updates will not be
      //      reflected immediately in errors. This is OK here
      //      because not-required fields get hidden (rendered
      //      as `null`), but this is not clean...
    }
  }
  return (
    <Section>
      <div className="row">
        {element.children.map(child => {
          const error = touched[child.name] && errors[child.name]; // TODO Clarify importance of this, or remove

          // Render first line of addresses as PlacesAutocomplete if Google Integration is used
          if (
            element.googleIntegration &&
            child.name.toLowerCase().includes('address1')
          ) {
            return (
              <div
                key={'googleIntegration' + child.name}
                className={classNames('form-group', 'col-12', 'mb-2')}
              >
                <Label>
                  {/* Label component uses props.children, so wrapping text in a span*/}
                  <span>{element.label}</span>
                </Label>
                <GoogleAddress
                  name={child.name}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values[child.name]}
                  errors={errors}
                  setFieldValue={setFieldValue}
                  children={element.children}
                  touched={touched}
                  {...child.props}
                />
              </div>
            );
          } else if (child.Component) {
            return (
              <NamedComponent
                key={child.name}
                child={child}
                error={error}
                handleBlur={handleBlur}
                handleChange={handleChange}
								touched={touched}
								values={values}
              />
            );
          } else {
            return (
              <GenericComponent
                key={child.name}
                child={child}
                error={error}
                handleBlur={handleBlur}
                handleChange={handleChange}
                touched={touched}
              />
            );
          }
        })}
      </div>
    </Section>
  );
}

/* Generic, unlabeled fields used with components of address (e.g. street, zip) */
function GenericComponent(props) {
  return (
    <section
      className={`form-group col-md-${props.child.col}`}
    >
      {props.child.label ? (
        <Label> {props.child.label}</Label>
      ) : (
        <div className="mt-2"></div>
      )}
      {props.child.label === 'Please Explain' ? (
        // Labeled field
        <Field
          name={props.child.name}
          as="textarea"
          onBlur={props.handleBlur}
          onChange={props.handleChange}
          placeholder={`${props.child.placeholder}`}
          className={classNames('form-control', {
            'is-invalid': props.touched[props.child.name] && props.error
          }, 'mb-2')}
          error={props.error}
        />
      ) : (
        // Generic field, if no label is given
        <Field
          name={props.child.name}
          placeholder={`${props.child.placeholder}`}
          className={classNames('form-control', {
            'is-invalid': props.touched[props.child.name] && props.error
          }, 'mb-2')}
          type="text"
        />
      )}
      <Error>{props.error}</Error>
    </section>
  );
}

function NamedComponent(props) {
	const Component = props.child.Component;
	return (
    <>
		<div className={classNames('form-group', `col-md-${props.child.col}`)}>
		{/* Labels aren't required on child components
		 * (e.g. on address subcomponents they are absent).
		 * They can be useful on grouped components
		 * (e.g. phone, mobile phone in same row)
		 */}
		{props.child.label ? (
			<Label>{props.child.label}</Label>
		) : (
			<div className="mt-2"></div>
		)}
		<Component
			name={props.child.name}
			onBlur={props.handleBlur}
			onChange={props.handleChange}
			value={props.values[props.child.name]}
			touched={props.touched}
			error={props.error}
		/>
		<Error>{props.error}</Error>
	</div>
  </>
	)
}

export default ComplexElement;
